<template>
  <div class="phone-frame">
    <div class="benefits-view">
    <!-- Header -->
    <header class="page-header">
      <span class="brand">续费社群 · 续费权益</span>
      <div class="header-right">
        <span class="username">{{ userName }}</span>
        <button class="logout-btn" @click="logout">退出</button>
      </div>
    </header>

    <div class="scroll-area">
      <!-- Price -->
      <div class="price-card">
        <div class="price-label">年度续费</div>
        <div class="price">¥3,000<span class="unit"> / 年</span></div>
        <div class="rules">
          <div class="rule-item">
            <span class="rule-dot">•</span> 到期前续费，从上期到期日算起
          </div>
          <div class="rule-item">
            <span class="rule-dot">•</span> 到期后续费，从当天算起
          </div>
        </div>
      </div>

      <!-- Space validity -->
      <div class="space-bar" v-if="spaceExpireDate">
        <span class="space-icon">📅</span>
        我的空间有效期至 <strong>{{ spaceExpireDate }}</strong>
      </div>

      <!-- 续费好礼 -->
      <div class="section">
        <h2 class="section-title">🎁 续费好礼</h2>
        <div class="gift-list">
          <div class="gift-card">
            <div class="gift-quantity">3 人次</div>
            <div class="gift-name">抚仙湖线下生命教育体验</div>
            <div class="gift-value">价值 ¥3,000</div>
          </div>
          <div class="gift-card">
            <div class="gift-quantity">12 次</div>
            <div class="gift-name">「观心好礼」月月惊喜</div>
            <div class="gift-value">全年陪伴，每月一礼</div>
          </div>
        </div>
      </div>

      <!-- 续费后你还可以 -->
      <div class="section">
        <h2 class="section-title">续费后你还可以</h2>
        <div class="benefit-list">
          <div class="benefit-item">
            <span class="benefit-icon">◆</span> 继续在平台学习和复训
          </div>
          <div class="benefit-item">
            <span class="benefit-icon">◆</span> 以大师姐/师兄身份参与 30 天营及各行动营
          </div>
          <div class="benefit-item">
            <span class="benefit-icon">◆</span> 围绕平台课程，自主组织共读、共学、练习与复盘
          </div>
          <div class="benefit-item">
            <span class="benefit-icon">◆</span> 保留已获得的认证身份与学习进度
          </div>
          <div class="benefit-item">
            <span class="benefit-icon">◆</span> 保有参与平台服务机会及收益资格
          </div>
        </div>
      </div>

      <!-- 不续费的话 -->
      <div class="section">
        <h2 class="section-title">不续费的话</h2>
        <div class="compare-box">
          <div class="compare-keep">
            <div class="compare-label">✓ 仍保留</div>
            <div class="compare-item">生命教练认证身份</div>
          </div>
          <div class="compare-lose">
            <div class="compare-label">✗ 将暂停</div>
            <div class="compare-item">平台学习 · 空间权限 · 复训资格</div>
            <div class="compare-item">共学支持 · 服务机会</div>
          </div>
        </div>
      </div>

      <div class="bottom-spacer"></div>
    </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const userName = ref("");
const spaceExpireDate = ref("");

onMounted(async () => {
  try {
    const token = localStorage.getItem("rc_token");
    if (!token) return;
    const res = await fetch("/api/auth/me", {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    if (data.user?.name) {
      userName.value = data.user.name;
    }
    const expire = data.user?.vipExpireTime;
    if (expire) {
      const d = new Date(expire);
      if (!isNaN(d.getTime())) {
        spaceExpireDate.value = `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, "0")}.${String(d.getDate()).padStart(2, "0")}`;
      }
    }
  } catch {
    // ignore
  }
});

function logout() {
  localStorage.removeItem("rc_token");
  router.push("/login");
}
</script>

<style scoped>
.phone-frame {
  max-width: 430px;
  margin: 0 auto;
  height: 100%;
  background: #fef9f2;
  box-shadow: 0 0 40px rgba(0,0,0,0.08);
  position: relative;
}

.benefits-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f0e8;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
}

/* Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #f0e8dd;
  flex-shrink: 0;
}

.brand {
  font-weight: 700;
  font-size: 16px;
  color: #e8894f;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.username {
  font-size: 13px;
  color: #8b7e6a;
}

.logout-btn {
  padding: 4px 10px;
  font-size: 11px;
  border: 1px solid #e8e4df;
  border-radius: 6px;
  background: none;
  color: #8b7e6a;
  cursor: pointer;
}

.page-subtitle {
  padding: 10px 16px;
  font-size: 13px;
  color: #b8a99a;
  background: #fff;
  border-bottom: 1px solid #f0ede9;
  flex-shrink: 0;
}

/* Scroll area */
.scroll-area {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  -webkit-overflow-scrolling: touch;
}

/* Price card */
.price-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px 24px 20px;
  text-align: center;
  margin-bottom: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}

.price-label {
  font-size: 13px;
  color: #b8a99a;
  margin-bottom: 4px;
}

.price {
  font-size: 36px;
  font-weight: 800;
  color: #e8894f;
  letter-spacing: -1px;
  margin-bottom: 14px;
}

.unit {
  font-size: 18px;
  font-weight: 500;
  color: #b8a99a;
}

.rules {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rule-item {
  font-size: 13px;
  color: #8b7e6a;
  line-height: 1.5;
}

.rule-dot {
  color: #e8894f;
  margin-right: 4px;
}

/* Space bar */
.space-bar {
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 14px;
  color: #3d3529;
  margin-bottom: 24px;
  text-align: center;
}

.space-bar strong {
  color: #e8894f;
}

.space-icon {
  margin-right: 4px;
}

/* Sections */
.section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #3d3529;
  margin-bottom: 12px;
}

/* Gift cards */
.gift-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gift-card {
  background: #fff;
  border-radius: 14px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
  border-left: 4px solid #e8894f;
}

.gift-quantity {
  font-size: 18px;
  font-weight: 800;
  color: #e8894f;
  white-space: nowrap;
  min-width: 56px;
}

.gift-name {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #3d3529;
  line-height: 1.4;
}

.gift-value {
  font-size: 12px;
  color: #b8a99a;
  white-space: nowrap;
  text-align: right;
}

/* Benefit list */
.benefit-list {
  background: #fff;
  border-radius: 14px;
  padding: 8px 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
}

.benefit-item {
  padding: 13px 20px;
  font-size: 14px;
  color: #3d3529;
  line-height: 1.5;
  border-bottom: 1px solid #faf8f5;
}

.benefit-item:last-child {
  border-bottom: none;
}

.benefit-icon {
  color: #e8894f;
  font-size: 10px;
  margin-right: 8px;
}

/* Compare box */
.compare-box {
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
}

.compare-keep {
  padding: 16px 20px;
  border-bottom: 1px solid #faf8f5;
}

.compare-lose {
  padding: 16px 20px;
}

.compare-label {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.compare-keep .compare-label {
  color: #5a9e6f;
}

.compare-lose .compare-label {
  color: #d4786e;
}

.compare-item {
  font-size: 13px;
  color: #8b7e6a;
  line-height: 1.6;
}

.bottom-spacer {
  height: 24px;
}
</style>
